// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","169":"component---src-templates-product-js"}[chunkId] || chunkId) + "-" + {"70":"1f2ef3bf0efdf615180a","125":"8ccaf5b9f8564b15ed6f","169":"d911cd0ea8ef6404d6bd","242":"7005dbfc3f1764d0b076","556":"242e7b40a7d5cd1673e0","995":"9ed2f2c059fe22e9cfc7"}[chunkId] + ".js";
};